import Alpine from 'alpinejs';
import GLightBox from 'glightbox'
import Glide from '@glidejs/glide'

window.Alpine = Alpine;
Alpine.start();

const lightbox = GLightBox();

document.querySelectorAll('[data-section-hero-carousel]').forEach(glide => {
    new Glide(glide, {
    }).mount();
});